import type { SVGProps } from 'react';
const DawnFlagAL = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <mask
      id="dawn-flag-AL_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AL_svg__a)">
      <path fill="#EE343C" d="M0 0h22v16H0z" />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="M9.818 3.597a.67.67 0 0 0-.85-.085l-.177.12a.667.667 0 0 0 .072 1.147l.728.37a.661.661 0 0 1-.3 1.25h-.226a.7.7 0 0 1-.303-.072l-1.517-.772a.67.67 0 0 0-.778.127l-.068.07a.667.667 0 0 0 .173 1.06l.58.296a.467.467 0 0 1 .05.803.467.467 0 0 0 .17.844l.43.087c.43.088.557.64.209.907l-.403.308a.34.34 0 0 0 .206.61.3.3 0 0 0 .084-.01l.976-.25a.433.433 0 0 1 .469.657.433.433 0 0 0 .362.67h.448c.193 0 .364.123.423.306.134.41.713.41.847 0a.445.445 0 0 1 .424-.307h.448c.344 0 .55-.382.362-.67a.433.433 0 0 1 .468-.655l.976.248q.042.01.084.01a.34.34 0 0 0 .207-.61l-.403-.307a.511.511 0 0 1 .208-.907l.43-.087a.467.467 0 0 0 .17-.844.467.467 0 0 1 .05-.803l.58-.296a.667.667 0 0 0 .174-1.06l-.068-.07a.67.67 0 0 0-.778-.127l-1.517.772a.7.7 0 0 1-.303.073h-.226a.661.661 0 0 1-.3-1.25l.728-.372a.667.667 0 0 0 .072-1.145l-.178-.12a.67.67 0 0 0-.85.084l-.706.719a.667.667 0 0 1-.95 0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagAL;
